import { combineReducers } from 'redux-immutable';
import * as types from './types';
import { StateModal } from './models';

export const stateModal = (state = StateModal(), action) => {
  switch (action.type) {
    case types.SET_MODAL: {
      return state.setIn(['isVisible'], action.payload.isVisible);
    }
    case types.GET_MODAL:
      return StateModal();
    default:
      return state;
  }
};

export default combineReducers({
  stateModal,
});

export const getModal = state =>
  state.getIn(['modal', 'stateModal']);
